import React, { useState, useRef, useEffect, Fragment } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import './ContactUs.css';

// Import EmailJS
import emailjs from '@emailjs/browser';

// Ikon untuk bagian "Info Kontak"
import iconMarker from "../assets/icon/white-map-marker-24px.png";
import iconEmail from "../assets/icon/white-mail-24px.png";
import iconPhone from "../assets/icon/white-phone-24px.png";

// Ikon media sosial
import linkMediaYoutube from "../assets/icon/info-youtube-logo-24px.png";
import linkMediaInstagram from "../assets/icon/info-instagram-24px.png";
import linkMediaFacebook from "../assets/icon/info-facebook-24px.png";
import linkMediaTwitter from "../assets/icon/info-twitter-24px.png";
import linkMediaLinkedIn from "../assets/icon/info-linkedin-24px.png";
import linkMediaTikTok from "../assets/icon/info-tiktok-24px.png";

import FloatingBackButton from "../interface/back_page_button/FloatingBackButton";
import FloatingBackToHome from "../interface/back_to_home/FloatingBackToHome";
import SEO from "../SEO/SEO";
import { open } from '../SocialMediaLinks/SocialMediaLinks';

function ContactUs() {
  /** single select on hover - Dipertahankan sesuai instruksi awal */
  function MouseOver(event) {
    event.target.style.background = '';
  }

  function MouseOut(event) {
    event.target.style.background = "";
  }

  /** multiple select handle this situation using useState() - Dipertahankan sesuai instruksi awal */
  let [over, setOver] = React.useState(false);

  let buttonstyle = {
    backgroundColor: ''
  }

  if (over) {
    buttonstyle.backgroundColor = "#2490E3";
  } else {
    buttonstyle.backgroundColor = '';
  }

  // Tambahkan useRef untuk referensi form
  const form = useRef();

  /** text promp keterangan pada input Nama Lengkap */
  function prompFirstName() {
    var x = document.getElementById("id-text-promp-first-name");
    if (x) {
      if (x.style.display === "inline") {
        x.style.display = "none";
      } else {
        x.style.display = "inline";
      }
    }
  }

  /** text promp keterangan pada input Email Address */
  function prompEmail() {
    var x = document.getElementById("id-text-promp-email");
    if (x) {
      if (x.style.display === "inline") {
        x.style.display = "none";
      } else {
        x.style.display = "inline";
      }
    }
  }

  /** text promp keterangan pada input Subjek Pesan */
  function prompSubject() {
    var x = document.getElementById("id-text-promp-subject");
    if (x) {
      if (x.style.display === "inline") {
        x.style.display = "none";
      } else {
        x.style.display = "inline";
      }
    }
  }

  /** text promp keterangan pada input Pesan Anda */
  function prompMessage() {
    var x = document.getElementById("id-text-promp-message");
    if (x) {
      if (x.style.display === "inline") {
        x.style.display = "none";
      } else {
        x.style.display = "inline";
      }
    }
  }

  /** text promp keterangan pada input nama terahir (fungsi lama, tetap dipertahankan meskipun tidak digunakan) */
  function prompLastName() {
    var x = document.getElementById("id-text-promp-last-name");
    if (x) {
      if (x.style.display === "block") {
        x.style.display = "none";
      } else {
        x.style.display = "block";
      }
    }
  }

  /** text promp keterangan pada input nomor hp (fungsi lama, tetap dipertahankan meskipun tidak digunakan) */
  function prompPhoneNumber() {
    var x = document.getElementById("id-text-promp-phone-number");
    if (x) {
      if (x.style.display === "block") {
        x.style.display = "none";
      } else {
        x.style.display = "block";
      }
    }
  }

  /** ----------------------------- sending email with EmailJS ------------------------------- */
  const sendEmail = (e) => {
    e.preventDefault(); // Mencegah form HTML default submit (reload halaman)

    // Dapatkan nilai input dari elemen formulir
    const fullName = document.getElementById("id-input-first-name").value.trim();
    const email = document.getElementById("id-input-email").value.trim();
    const subject = document.getElementById("id-input-subject").value.trim();
    const message = document.getElementById("id-input-body").value.trim();

    // --- Validasi Semua Bidang Kosong ---
    if (!fullName || !email || !subject || !message) {
      alert("Harap lengkapi semua bidang formulir yang wajib diisi.");
      return; // Hentikan fungsi jika ada bidang yang kosong
    }

    // --- Validasi Format Email dengan Kontrol Custom Domain ---
    // Regex yang lebih ketat untuk email, mendukung TLD internasional dan domain custom
    // Memungkinkan subdomain, karakter alfanumerik, titik, dan strip dalam domain
    // Memeriksa TLD minimal 2 karakter
    const emailRegex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (!emailRegex.test(email)) {
      alert("Format alamat email tidak valid. Harap periksa kembali.");
      return; // Hentikan fungsi jika format email tidak valid
    }

    // Menggunakan ID service, template, dan public key Anda dari EmailJS
    // GANTI DENGAN KUNCI ASLI ANDA DARI EMAILJS!
    const SERVICE_ID = "service_94p0h3k";
    const TEMPLATE_ID = "template_dv6dyoj";
    const PUBLIC_KEY = "Fm6BAT3xUbQ7N8Sf0";

    // Objek templateParams harus cocok dengan variabel di template EmailJS Anda
    const templateParams = {
      user_full_name: fullName,
      user_email: email,
      subject: subject,
      message: message,
    };

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then((result) => {
          console.log("Email berhasil dikirim:", result.text);
          alert('Pesan Anda berhasil terkirim!');
          // --- Reset Form Setelah Berhasil ---
          if (form.current) { // Pastikan form.current ada sebelum mereset
            form.current.reset();
          }
      }, (error) => {
          console.error("Gagal mengirim email:", error.text);
          alert('Gagal mengirim pesan. Silakan coba lagi nanti.');
      });
  };

  /* navigation on click */
  function openLink(urls) {
    window.open(urls);
  }

  /** navigation to from div clicked */
  const navigate = useNavigate();

  return (
    <div className="contact-us fade new-layout-container" id="contact-us">

      <SEO
        title="Hubungi Kami - Rekanata Konstruksi"
        description="Rekanata adalah jasa kontraktor profesional yang siap melayani Anda di seluruh Indonesia."
        canonical="https://rekanata.com/contact-us"
      />

      <FloatingBackToHome />

      {/* Latar belakang putih solid */}
      <div className="bg" />
      <div className="bg-overlay" />

      {/* Kontainer utama untuk konten form dan info */}
      <div className="container new-layout-content">
        <div className="base-header new-layout-card">
          {/* Kolom Kiri: Formulir Kontak "Kontak Kami" */}
          <div className="contact-left">
            <h1 className="contact-me">Kontak Kami.</h1>
            <p className="feel-free">
              Kami siap melayani Anda dengan sepenuh hati. Silakan hubungi kami kapan saja melalui formulir di bawah ini untuk pertanyaan, kolaborasi, atau kebutuhan konstruksi Anda. Tim ahli kami akan segera merespons.
            </p>

            {/* Mengubah form agar menggunakan onSubmit dan ref */}
            <form className="contact-form-elements" ref={form} onSubmit={sendEmail}>
              <div className="form-grid">
                <div className="form-group">
                  <div className="label-and-promp">
                    <label htmlFor="id-input-first-name">Nama Lengkap</label>
                    <a id="id-text-promp-first-name" className="text-promp" style={{ display: 'none' }}>: (Wajib di isi)</a>
                  </div>
                  <input
                    className="contact-us-input"
                    type="text"
                    autoComplete="off"
                    id="id-input-first-name"
                    name="user_full_name" // Penting: Sesuaikan dengan nama variabel di template EmailJS
                    placeholder=""
                    onMouseEnter={prompFirstName}
                    onMouseLeave={prompFirstName}
                  />
                </div>

                <div className="form-group">
                  <div className="label-and-promp">
                    <label htmlFor="id-input-email">Alamat Email</label>
                    <a id="id-text-promp-email" className="text-promp" style={{ display: 'none' }}>: (Wajib di isi)</a>
                  </div>
                  <input
                    className="contact-us-input"
                    type="email"
                    autoComplete="off"
                    id="id-input-email"
                    name="user_email" // Penting: Sesuaikan dengan nama variabel di template EmailJS
                    placeholder=""
                    onMouseEnter={prompEmail}
                    onMouseLeave={prompEmail}
                  />
                </div>

                <div className="form-group full-width">
                  <div className="label-and-promp">
                    <label htmlFor="id-input-subject">Subjek Pesan</label>
                    <a id="id-text-promp-subject" className="text-promp" style={{ display: 'none' }}>: (Wajib di isi)</a>
                  </div>
                  <input
                    className="contact-us-input"
                    type="text"
                    autoComplete="off"
                    id="id-input-subject"
                    name="subject" // Penting: Sesuaikan dengan nama variabel di template EmailJS
                    placeholder=""
                    onMouseEnter={prompSubject}
                    onMouseLeave={prompSubject}
                  />
                </div>

                <div className="form-group full-width">
                  <div className="label-and-promp">
                    <label htmlFor="id-input-body">Pesan Anda</label>
                    <a id="id-text-promp-message" className="text-promp" style={{ display: 'none' }}>: (Wajib di isi)</a>
                  </div>
                  <textarea
                    className="contact-us-textarea"
                    id="id-input-body"
                    name="message" // Penting: Sesuaikan dengan nama variabel di template EmailJS
                    placeholder=""
                    onMouseEnter={prompMessage}
                    onMouseLeave={prompMessage}
                  />
                </div>

                <button type="submit" className="button-send-message">KIRIM PESAN</button>
              </div>
            </form>
          </div>

          {/* Kolom Kanan: "Info Kontak" */}
          <div className="contact-right">
            <h3 className="need-help" >Info Kontak</h3>
            <p className="help-text">
              Untuk informasi lebih lanjut, pertanyaan seputar proyek, atau kerjasama, jangan ragu untuk menghubungi kami melalui detail kontak di bawah ini. Tim kami siap memberikan bantuan dan solusi terbaik.
            </p>

            {/* Konten informasi kontak */}
            <div className="contact-info-list">
              <h3 className="need-help" >Alamat</h3>
              <div className="list-item">
                <span>Jalan Cimincrang, Kavling Pos Giro no 10, Cimenerang, Kec. Gedebage, Kota Bandung, Jawa Barat 40295 Indonesia.</span>
              </div>
              <div className="list-item">
                <span>rekanata.constractors@gmail.com</span>
              </div>
              <div className="list-item">
                <span>+62 821 1000 2640</span>
              </div>
            </div>

            <h3 className="need-help" >Sosial Media</h3>

            {/* Ikon media sosial dengan gambar bulat */}
            <div className="social-icons-container">
              <div className="social-icon-wrapper" onClick={open.Youtube}>
                <img src={linkMediaYoutube} className="social-icon" alt="YouTube" />
              </div>
              <div className="social-icon-wrapper" onClick={open.Instagram}>
                <img src={linkMediaInstagram} className="social-icon" alt="Instagram" />
              </div>
              <div className="social-icon-wrapper" onClick={open.Facebook}>
                <img src={linkMediaFacebook} className="social-icon" alt="Facebook" />
              </div>
              <div className="social-icon-wrapper" onClick={open.Twitter}>
                <img src={linkMediaTwitter} className="social-icon" alt="Twitter" />
              </div>
              <div className="social-icon-wrapper" onClick={open.LinkedIn}>
                <img src={linkMediaLinkedIn} className="social-icon" alt="LinkedIn" />
              </div>
              <div className="social-icon-wrapper" onClick={open.TikTok}>
                <img src={linkMediaTikTok} className="social-icon" alt="TikTok" />
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
}

export default ContactUs;